
export const sFechaPublicacion = '2026-11-02T19:09:20.0963019-06:00';
export const sVersion = 'vf1.1.611021909';
            